export const consent = {
  consent: {
     consentText: `Apex Tool Group, LLC and its affiliates (“ATG,” “we,” “us,” or “our”) have implemented this California Notice of Employment Privacy Practices (the “Notice”) to address the requirements of the California Consumer Privacy Act of 2018, as amended by the California Privacy Rights Act (collectively with all implementing regulations, “CCPA”). This Notice applies solely to California residents whose personal information is collected by ATG in the following situations:`,
    consentCheckbox: `I have read and agree to the Terms & Conditions and Privacy Policy.`,
    proceed: `Proceed`,
    Close: `Close`
  },
};
